import axios from './api' // 倒入 api

/* 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 * 此处的数据依然来自 Easy Mock
 */

// 单独倒出
export const query = params => {
  return axios({
    url: 'static/data.json',
    method: 'get',
    baseURL:'/api',
    params:{

    }
  })
}

export const mock = params => {
  return axios({
    url: '/mock',
    method: 'get',
    baseURL:'/api',
    params
  })
}

export const upload = data => {
  return axios({
    url: '/upload',
    method: 'post',
    baseURL:'/api',
    data
  })
}

export function appAccessToken(url) {
  return axios({
    url: url,
    method: 'post',
    baseURL:'/api',
  });
}


//获取树节点
export const getTreeNode = data => {
  return axios({
    url: '/IQCloudManageCenter/orgManageController/selectOrgTreeChild',
    method: 'post',
    baseURL:'/api',
    data
  })
}

//获取开机率和开机时长
export const getEquipmentOpenInfo = data =>{
  return axios({
    url:'/IQEquipment/centralizedController/selectEquipmentOpenInfo',
    method:'post',
    baseURL:'/api',
    data
  })
}

//login //用户登陆
// export function login(url,params) {
//   console.log(params)
//   return axios({
//     url: url,
//     method: 'post',
//     data:params
//   });
// }
// export function login(url,params) {
//   console.log(params)
//   return axios({
//     url: url,
//     method: 'post',
//     data:params
//   });
// }

// 默认全部倒出
// 根绝需要进行
export default {
  query,
  mock,
  upload,
  appAccessToken,
  getTreeNode,
  getEquipmentOpenInfo,
}



// WEBPACK FOOTER //
// ./src/http/interface.js